import script from "./TextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=aaf474c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaf474c6"]])

export default __exports__